<template lang="pug">
div
  v-dialog(
    v-model='showInfoUser'
    :fullscreen="isMovil"
    :hide-overlay="isMovil"
    transition='dialog-bottom-transition',
    :width="isMovil ? '100%' : '500'"
  )
    item-usuario(
      is-fetch
      :username="ticket.usuario"
      show-details
    )
  v-dialog(
    v-model='isUploadFiles',
    :max-width="isMovil ? '100%' : '60%'",
    transition='dialog-bottom-transition',
    :fullscreen="isMovil"
  )
    v-card
      adjuntar-archivos(
        @close="closeModalAdjuntar",
        ref="archivos-nota-credito",
        v-if="isUploadFiles",
        :multiple="false"
        @save="setFilesToSave"
        :extensions="['pdf', 'jpg', 'png', 'jpeg']"
      )
  v-dialog(v-model='isModalIntegracion'  width='500' min-height="500" )
    v-card.pa-4
      .px-2.pt-2.text-center.flex.d-flex.fd-column.ai-center
        .text-center.font-weight-700.font-size-18 GENERAR INFORME TECNICO - {{ticket.serie }}
        .text-center.flex.d-flex.jc-center.banner-ok(
          v-if="!isLoadingGetSerie && datosSerieInforme && !datosSerieInforme.clienteSinDeudas"
        ) CLIENTE SIN DEUDA

        .text-center.flex.d-flex.jc-center.banner-deuda(
            v-if="!isLoadingGetSerie && datosSerieInforme && datosSerieInforme.clienteSinDeudas"
          ) CLIENTE CON DEUDA
      v-card-text(v-if="isLoadingGetSerie")
        span Cargando ...
      v-card-text(v-else)
        v-row.mt-4
          v-col(cols="12" md='12')
            v-autocomplete(:items="tiposInformeFiltrado" item-text="name" item-value="code" label='Tipo' dense='' v-model="tipoIntegracion"  hide-details :disabled="isGenerarITGarantia")
        v-row(v-if="!isGenerarITGarantia")
          v-col(cols="12" md='12', )
            v-autocomplete.mt-1(
              :loading="isGettingFallas"
              dense,
              hide-details
              item-text="descripcionFallaGeneral"
              item-value="codigoFallaGeneral"
              v-model='fallaSeleccionada'
              return-object
              :items='fallas'
              placeholder="Falla"
            )
        v-row(v-if="!isGenerarITGarantia")
          v-col(cols="12" md='12', )
            listado-direcciones-seleccionar(v-if="isModalIntegracion" :codigo="datosSerieInforme.codigoClienteSap" :id="direccionSeleccionado.id" @selected="getDireccion")
        v-row(v-if="!isGenerarITGarantia")
          v-col(cols="12" md='12')
            v-autocomplete.mt-1(
              :loading="isLoadingUbigeos"
              dense,
              hide-details
              item-text="descripcion"
              item-value="ubigeo"
              v-model='ubigeoSeleccionado'
              return-object
              :items='ubigeos'
              placeholder="Ubigeo"
            )
            //- v-text-field( dense  type="text" label="Ubigeo *" v-model="datosSerieInforme.ubigeo" :hint="datosSerieInforme.descripcionUbigeo || 'Ninguno'"  persistent-hint)
        v-row(v-if="!isGenerarITGarantia")
          v-col(cols="12" md='6', )
            v-text-field( dense type="text"  label='Ubicacion equipo *' v-model="datosSerieInforme.extra" hide-details)
          v-col(cols="12" md='6')
            v-text-field( dense  type="text" label="Telefono contacto *" v-model="datosSerieInforme.telefono" hide-details )
        v-row(v-if="!isGenerarITGarantia")
          v-col(cols="12" md='6', )
            v-text-field( dense type="text"  label='Email contacto*' v-model="datosSerieInforme.email"  hide-details)
          v-col(cols="12" md='6')
            v-text-field( dense  type="text" label="Nombre contacto *" v-model="datosSerieInforme.contacto" hide-details)
        //- v-row(v-if="!isGenerarITGarantia")
        //-   v-col(cols="12" md='12', )
        //-     v-text-field( dense type="text"  label='Tecnico' v-model="datosSerieInforme.codigoTecnico"  hide-details)
        //- v-row(v-if="!isGenerarITGarantia")
        //-   v-col(cols="12" md='6', )
        //-     v-text-field( dense type="text"  label='Fecha visita' v-model="datosSerieInforme.codigoTecnico"  hide-details)
        //-   v-col(cols="12" md='6')
        //-     v-text-field( dense  type="date" label="Hora visita" v-model="datosSerieInforme.fechaVisita" hide-details)
        v-row(v-if="!isGenerarITGarantia")
          v-col(cols="12" md='12')
            v-text-field( dense  type="text" label="Observacion para el informe*" v-model="datosSerieInforme.observacion" hide-details)

      v-card-actions
        v-btn.mt-4(color='primary'  block  @click='fetchIntegrarTicket()')
          small Continuar
  v-dialog(
    v-model='isModalAsignacionZona'
    width='350'
    min-height="350"
  )
    v-card.pa-6
      .px-4.py-3
        .text-center.font-weight-700.font-size-18 Actualiza el area y zona de garantia
      .d-flex
        .d-flex.fd-column
          .flex-1
            span.font-weight-700.font-size-13 Area
            v-radio-group.py-0.mb-6.mt-2(column v-model='ticket.tipoArea' v-if="ticket.numero"  hide-details :disabled="isLoadingChangeTipoArea || perfil === 'supervisor'", @change="fetchActualizarTipoArea()" )
              v-radio(value='campo')
                template(v-slot:label='')
                  strong(:class="{'primary--text' : ticket.tipoArea === 'campo'}") Campo
              v-radio(value='taller')
                template(v-slot:label='')
                  strong(:class="{'primary--text' : ticket.tipoArea === 'taller'}") Taller
              v-radio(value='sin asignacion')
                template(v-slot:label='')
                  strong(:class="{'primary--text' : ticket.tipoArea === 'sin asignacion'}") Sin asignación
          .flex-1
            span.font-weight-700.font-size-13 Zona
            v-radio-group.py-0.mt-2(column v-model='ticket.zonaGarantia' v-if="ticket.numero"  hide-details :disabled="isLoadingChangeZonaGarantia || perfil === 'supervisor'", @change="fetchActualizaZonaGarantia()" )
              v-radio(value='lima')
                template(v-slot:label='')
                  strong(:class="{'primary--text' : ticket.zonaGarantia === 'lima'}") Lima
              v-radio(value='arequipa')
                template(v-slot:label='')
                  strong(:class="{'primary--text' : ticket.zonaGarantia === 'arequipa'}") Arequipa
              v-radio(value='sin asignacion')
                template(v-slot:label='')
                  strong(:class="{'primary--text' : ticket.zonaGarantia === 'sin asignacion'}") Sin asignación
          .d-flex.mt-8
            p.font-size-11.text-muted.my-2.mb-0 Al realizar el cambio de area y zona se le notificará a los dispatcher que pertenezcan a la zona que selecciones.

  //- v-dialog(v-model='isModalEditarCita'  width='40%' min-height="500")
  v-dialog(
    v-model='isModalEditarCita'
    transition='dialog-top-transition',
    :width="isMovil ? '100%' : '450'",
    :fullscreen="isMovil"
    :hide-overlay="isMovil"
  )
    form-cita(
      :id="ticket.idCita",
      v-if="isModalEditarCita",
      @close="closeModalEditarCita()",
      @update="fetch(); $refs.activity.fetchActividades(true)",
      :is-creacion-externo="!isCreacionExterno",
      no-esta-en-agenda
      :numero-ticket="ticket.numero"
    )
  v-tabs.elevation-1.position-sticky(
    fixed-tabs=''
    v-if="isMovil"
  )
    v-tab(@click="tabActive = 1")
      small detalles
    v-tab(@click="tabActive = 2")
      small actividades
    v-tab(@click="tabActive = 3", v-if="perfil !== 'usuario-contrato' && perfil !== 'usuario-contrato' && ticket.abierto")
      small acciones
  .pa-3
    v-dialog(
      v-model='isAddMessageChanges'
      width="450",
      @click:outside="closeModalAddMessage()"
      transition='dialog-bottom-transition'
    )
      v-card.pa-2
        h1.text-center.font-weight-700.font-size-18.py-2 ¿Deseas agregar algún comentario para los cambios que se van a realizar?
        .pa-4
          v-textarea(
            hide-details,
            autofocus
            ref="comentarioChanges"
            v-model='comentarioChanges'
            placeholder='Describe (opcional)'
            color="primary"
            solo
            dense,
            rows="6"
          )
        v-card-actions
          //- v-spacer
          //- v-btn(color='primary'  v-if="!isMovil" text='' small @click='closeModalAddMessage()')
          //-   | Cancelar
          v-btn(color='success' block :small="!isMovil" @click='fetchActualizarDatosTicket()')
            | Confirmar los cambios
    v-dialog(
      v-model='isModalAnularTicket'
      width="450",
      @click:outside="closeModalAnular()"
      transition='dialog-bottom-transition'
    )
      v-card.pa-2
        h1.text-center.font-weight-700.font-size-18.py-2 ¿Estas seguro que deseas anular el ticket?
        .pa-4
          v-textarea(
            hide-details,
            autofocus
            ref="comentarioParaAnular"
            v-model='comentarioParaAnular'
            placeholder='Describe un motivo por el cual deseas anular el ticket'
            color="primary"
            solo
            dense,
            rows="6"
          )
        v-card-actions
          v-spacer
          v-btn(color='primary'  v-if="!isMovil" text='' small @click='closeModalAnular()')
            | Cancelar
          v-btn(color='primary' :block="isMovil" :small="!isMovil" @click='fetchCloseTicket()')
            | Anular ticket
    v-dialog(
      v-model='showModalDataSerie'
      :fullscreen="isMovil"
      :hide-overlay="isMovil"
      transition='dialog-bottom-transition',
      :width="isMovil ? '100%' : '500'"
      @click:outside="closeModalDataSerie()"
    )
      v-card(v-if="showModalDataSerie")
        v-card-text.pa-0
          item-serie(:serie="ticket.serie", :tipo-ticket="ticket.tipoticket" @close="closeModalDataSerie()")
    v-dialog(
      v-model='showModalFacturasAsociadas'
      :fullscreen="isMovil"
      :hide-overlay="isMovil"
      transition='dialog-bottom-transition',
      :width="isMovil ? '100%' : '500'"
      @click:outside="closeModalFacturasAsociadas()"
    )
      v-card(v-if="showModalFacturasAsociadas")
        v-card-text.pt-4
          .flex.fd-column.py-0(  dense )
            h2
              strong  Facturas asociadas a la serie {{ticket.serie}}
            v-radio-group.py-0.mt-4(row v-model='empresaFacturasAsociadas'   hide-details :disabled="isLoadingFacturasAsociados", @change="fetchFacturasAsociadas()" )
              v-radio(value='datacont')
                template(v-slot:label='')
                  strong(:class="{'primary--text' : empresaFacturasAsociadas === 'datacont'}") Datacont
              v-radio(value='reprodata')
                template(v-slot:label='')
                  strong(:class="{'primary--text' : empresaFacturasAsociadas === 'reprodata'}") Reprodata
          .flex.pa-4.ai-center.jc-center(v-if="isLoadingFacturasAsociados")
            v-progress-circular.indeterminate(color="primary")
          v-card.px-4.py-3.mt-4(v-else v-for="(factura, index) in dataFacturasAsociadas" :key="index")
            .flex.fd-column
              .d-flex
                h4.primary--text.font-weight-700 {{factura.FolioPrefFactura}} - {{factura.FolioNumFactura}}
                v-spacer
                v-chip.font-size-11.bold  {{factura.fechaFactura}}
              strong.font-size-11  {{factura.nombreCliente}}
            .flex.fd-column
              span.font-size-11  {{factura.codigoArticulo}} - {{factura.descripcionArticulo}}
            .flex.fd-column(v-if="factura.pdfFactura")
              v-btn.flex-uno.mt-2.width-full(color='primary' :block="isMovil" :small="!isMovil" @click='goToPdfFacturaAsociada(factura.pdfFactura)')
                | Ver PDF de la factura
          .flex.py-4.ai-center.jc-center(v-if="!isLoadingFacturasAsociados && !dataFacturasAsociadas.length")
            span.text-danger No existen facturas asociadas para esta serie

    v-row
      v-col(
        :md="perfil !== 'usuario-contrato' && perfil !== 'usuario' && ticket.abierto ? '3' : '4'",
        v-if="!isMovil || isMovil && tabActive === 1"
      )
        .flex-1.mb-4(
          v-if="ticket.numero && (perfil === 'usuario-contrato' || perfil === 'usuario') && ticket.abierto"
        )
          v-btn.width-full(
            color="primary",
            @click="isModalAnularTicket = true"
            :disabled="ticket.estado >= 13 && ticket.tipoticket === 'garantia'"
            :small="!isMovil"
          )
            v-icon.mr-1  block
            | Anular ticket
          strong.font-size-11(v-if="ticket.estado >= 13 && ticket.tipoticket === 'garantia'") No se puede anular el ticket por que el equipo ya ingreso al taller
        v-alert(icon='error' outlined text='', dense type='error', v-if="ticket.numero && !ticket.abierto")
          span.font-size-15.font-weight-700 El ticket se encuentra cerrado
          .d-flex
            small.font-weight-700 fecha de cierre {{ticket.fechaQueSeCerro | formatoFecha}}
        v-expansion-panels(v-model='panel' multiple='')
          v-expansion-panel(key='usuario', v-if="ticket.usuario && perfil !== 'usuario-contrato' && perfil !== 'usuario-contrato' ")
            v-expansion-panel-header.pa-2
              strong.font-weight-700
                .d-flex.ai-center
                  v-icon.mr-2.primary-color perm_identity
                  span.font-size-12 Información del usuario
            v-expansion-panel-content
              v-list.pa-0(dense)
                v-list-item.px-0
                  v-list-item-content
                    v-list-item-title(v-text='ticket.razonSocial')
                    v-list-item-subtitle(v-text="ticket.usuario")
                v-list-item.px-0
                  v-list-item-content
                    v-btn(color="primary", :small="!isMovil"  @click="showInfoUser = true")
                      v-icon.mr-3  visibility
                      | mas Información

          v-expansion-panel(key='cita_programada', v-if="ticket.idCita")
            v-expansion-panel-header.pa-2
              v-skeleton-loader(v-if="!ticket.numero" type='list-item')
              strong.font-weight-700(v-else)
                .d-flex.ai-center
                  v-icon.mr-2.primary-color date_range
                  span.font-size-12 Información de la cita
            v-expansion-panel-content
              v-card.elevation-0(key="ticketSeleccionada")
                v-list.py-0(dense)
                  v-list-item
                    v-list-item-content.py-0
                      v-list-item-title
                        span.font-weight-700.font-size-14.primary--text {{datosCita.fechaCita}} {{datosCita.horaCita}}
                      v-list-item-subtitle.grey--text.font-size-11 Fué programado  {{datosCita.fechaRegistro | now}}
                    v-list-item-action
                      v-btn(color="success", fab small, @click="isModalEditarCita = true" :disabled="perfil === 'supervisor'" v-if="perfil !== 'usuario-contrato' && perfil !== 'usuario-contrato'")
                        v-icon edit

          v-expansion-panel(key='permisos_tecnico' v-if="ticket.codigoTecnico && ticket.tipoticket !== 'contrato'")
          v-expansion-panel(key='ticket')
            v-expansion-panel-header.pa-2
              v-skeleton-loader(v-if="!ticket.numero" type='list-item')
              .d-flex.ai-center(v-else)
                v-icon.mr-2.primary-color info_outline
                strong.font-size-12.font-weight-700 Información del ticket
                small.text-muted.font-size-11.ml-2 (se registró {{ticket.fechaRegistro | now}})
            v-expansion-panel-content
              v-skeleton-loader(v-if="!ticket.numero" type='card')
              v-list.py-0(  dense v-else)
                v-list-item.px-0
                  v-list-item-content
                    h2.primary--text.font-weight-700 {{`#${ticket.numero}`}}
                    v-list-item-title.font-weight-700
                      strong.font-size-11 &nbsp;  {{ticket.tipoticket ? ticket.tipoticket.toUpperCase() : ''}}
                v-list-item.px-0(v-if="perfil !== 'usuario' && perfil !== 'usuario-contrato'")
                  v-list-item-content.py-0
                    v-list-item-subtitle  Numero informe tecnico
                    v-list-item-title.font-weight-700(:class="{'error--text' : !ticket.numeroInformeTecnico}") {{ticket.numeroInformeTecnico ? ticket.numeroInformeTecnico : '--'}}
                v-list-item.px-0(v-if="perfil !== 'usuario' && perfil !== 'usuario-contrato' && ticket.tipoticket === 'garantia'")
                  v-list-item-content.py-0
                    v-list-item-subtitle  Numero solicitud orden de compra
                    v-list-item-title.font-weight-700(:class="{'error--text' : !ticket.numeroSolicitudOrdenCompra}") {{ticket.numeroSolicitudOrdenCompra ? ticket.numeroSolicitudOrdenCompra : '--'}}
                v-list-item.px-0(v-if="perfil !== 'usuario' && perfil !== 'usuario-contrato' && ticket.tipoticket === 'garantia'")
                  v-list-item-content.py-0
                    v-list-item-subtitle  Numero solicitud parte de ingreso
                    v-list-item-title.font-weight-700(:class="{'error--text' : !ticket.numeroParteIngreso}") {{ticket.numeroParteIngreso ? ticket.numeroParteIngreso : '--'}}
                v-list-item.px-0(v-if="ticket.tipoticket === 'solicitud de insumo'")
                  v-list-item-content.py-0
                    v-list-item-subtitle  Insumos solicitados
                    .d-flex.fd-column
                      strong.font-size-12(v-for="(insumo, index) in ticket.insumo" :key="index") - {{ insumo }}
                v-list-item.px-0(v-if="ticket.tipoticket === 'solicitud de insumo'")
                  v-list-item-content.py-0
                    v-list-item-subtitle  Dirección de entrega
                    v-list-item-title
                      span {{ticket.direccion}} - ({{ticket.departamento}}/{{ticket.provincia}}/{{ticket.distrito}})
                v-list-item.px-0(v-if="ticket.tipoticket === 'solicitud de insumo'")
                  v-list-item-content.py-0
                    v-list-item-subtitle  Nombre contacto
                    v-list-item-title.font-weight-700(:class="{'error--text' : !ticket.nombreContacto}") {{ticket.nombreContacto ? ticket.nombreContacto : '--'}}
                v-list-item.px-0(v-if="ticket.tipoticket === 'solicitud de insumo'")
                  v-list-item-content.py-0
                    v-list-item-subtitle  Telefono contacto
                    v-list-item-title.font-weight-700(:class="{'error--text' : !ticket.numeroTelefono}") {{ticket.numeroTelefono ? ticket.numeroTelefono : '--'}}
                v-list-item.px-0(v-if="ticket.tipoticket === 'solicitud de insumo'")
                  v-list-item-content.py-0
                    v-list-item-subtitle  Ultimo contador
                    v-list-item-title.font-weight-700(:class="{'error--text' : !ticket.contadorActual}") {{ticket.contadorActual ? ticket.contadorActual : '--'}}
                v-divider
                .d-flex.fd-column.mt-2
                  span.font-size-12.gray--text.font-weight-700 Descripción de la falla
                  v-alert.my-1.word-break-message(icon='handyman'  text='' dense type='warning', v-if="ticket.descripcionFalla")
                    .d-flex.fd-column
                      span.font-size-14.font-weight-700 {{ticket.descripcionFalla}}
                      span.font-size-11.font-italic.pt-2 "{{ticket.comentarioFalla}}"
                  span.font-weight-700.font-size-12( v-else :class="{'error--text' : !ticket.comentarioFalla}") No se especificado

                .d-flex.fd-column.mt-2
                  span.font-size-12.gray--text.font-weight-700 Comentario general
                  v-alert.my-1.word-break-message(icon='mark_chat_unread'  text='' type='info', v-if="ticket.comentarioGeneral")
                    span.font-size-11.font-italic
                      | "{{ticket.comentarioGeneral}}"
                  span.font-weight-700.font-size-12( v-else :class="{'error--text' : !ticket.comentarioGeneral}") No se especificado
                .d-flex.fd-column.mt-2
                  span.font-size-12.gray--text.font-weight-700 Estado actual del ticket

                  span.font-weight-700.font-size-12.primary--text.text-uppercase {{ticket.descripcionEstado}}
                v-list-item.px-0(v-if="ticket.numeroInformeTecnico && ticket.urlGuiaRecepcionFirmada" @click="openInformeDeRecepcion()")
                  v-list-item-content.py-0
                    v-list-item-subtitle  Informe de recepción
                    v-list-item-title.font-weight-700
                      v-btn.animated.fadeInUp.faster(small, block color="primary" @click="openInformeDeRecepcion()")
                        v-icon  visibility
                        | &nbsp;  Visualizar

          v-expansion-panel(key='equipo')
            v-expansion-panel-header.pa-2
              v-skeleton-loader(v-if="!ticket.numero" type='list-item')
              strong.font-weight-700(v-else)
                .d-flex.ai-center
                  v-icon.mr-2.primary-color category
                  span.font-size-12 Información del equipo
            v-expansion-panel-content
              v-skeleton-loader(v-if="!ticket.numero" type='list-item-avatar-two-line')
              v-list.py-0(  dense v-else)
                v-list-item(v-if="ticket.marca")
                  v-img(:src="`${apiUpload}/upload/octopus/marcas/${ticket.marca}.jpg`", width="70", height="70" contain)
                v-list-item.px-0
                  v-list-item-content.py-0
                    v-list-item-subtitle  Marca
                    v-list-item-title.font-weight-700(:class="{'error--text' : !ticket.marca}") {{ticket.marca ? ticket.marca : '--'}}
                v-list-item.px-0(v-if="ticket.numero")
                  v-list-item-content.py-0
                    v-list-item-subtitle  Serie
                    v-list-item-title.font-weight-700(:class="{'error--text' : !ticket.serie}")
                      .d-flex(class="flex-column")
                        span.mb-2 {{ticket.serie ? ticket.serie : '--'}}
                        v-select(
                          v-if="seriesRepetidas.length > 0"
                          dense
                          v-model='ticket.numeroTicketRepetido'
                          :items='seriesRepetidas'
                          label="Series en tickes repetidos"
                          item-text="numero"
                          item-value="id"
                          @change="goTicket"
                        )
                        v-btn.mb-2(v-if="perfil !== 'usuario' && perfil !== 'usuario-contrato' && ticket.serie" color="info", :small="!isMovil"  @click="goToHistoriaTecnica()")
                          v-icon.mr-2(size="14")  link
                          small Historia tecnica
                        v-btn.mb-2(v-if="ticket.tipoticket === 'garantia' && ticket.serie" color="primary", :small="!isMovil"  @click="openModalFacturasAsociadas()")
                          v-icon.mr-2(size="14")  link
                          small Facturas asociadas
                v-list-item.px-0
                  v-list-item-content.py-0
                    v-list-item-subtitle  Descripcion equipo
                    v-list-item-title.font-weight-700(:class="{'error--text' : !ticket.descripcion}") {{ticket.descripcion ? ticket.descripcion : '--'}}
                v-list-item.px-0
                  v-list-item-content.py-0
                    v-list-item-subtitle  Codigo equipo
                    v-list-item-title.font-weight-700(:class="{'error--text' : !ticket.codigoArticulo}") {{ticket.codigoArticulo ? ticket.codigoArticulo : '--'}}
                v-list-item.px-0
                  v-list-item-content.py-0
                    v-list-item-subtitle  Modelo equipo
                    v-list-item-title.font-weight-700(:class="{'error--text' : !ticket.modelo}") {{ticket.modelo ? ticket.modelo : '--'}}
                v-list-item.px-0(v-if="ticket.tipoticket === 'garantia'")
                  v-list-item-content.py-0
                    v-list-item-subtitle Factura electronica
                    v-list-item-title.font-weight-700(:class="{'error--text' : !ticket.factura}") {{ticket.factura ? ticket.factura : 'No asignado'}}
                v-divider(v-if="ticket.ubigeo")
                v-list-item.px-0(v-if="ticket.ubigeo")
                  v-list-item-avatar
                    v-icon.background
                      | location_on
                  v-list-item-content.py-0
                    v-list-item-title {{ticket.direccion}}
                    v-list-item-subtitle.font-size-12.font-weight-700 ({{ticket.ubigeo}}) / {{ticket.departamento}} - {{ticket.provincia}} - {{ticket.distrito}}

          v-expansion-panel(key='contrato', v-if="ticket.tipoticket !== 'garantia'")
            v-expansion-panel-header.pa-2
              v-skeleton-loader(v-if="!ticket.numero" type='list-item')
              strong.font-weight-700(v-else)
                .d-flex.ai-center
                  v-icon.mr-2.primary-color receipt_long
                  span.font-size-12 Información del contrato
                  span.font-size-12.info--text.ml-2 # {{datosContrato.numeroContrato}}

            v-expansion-panel-content
              v-skeleton-loader(v-if="!ticket.numero" type='list-item-avatar-two-line')
              v-list.py-0(  dense v-else)
                v-list-item.px-0
                  v-list-item-content.py-0
                    v-list-item-subtitle  Empresa
                    v-list-item-title.font-weight-700(:class="{'error--text' : !datosContrato.empresa}") {{datosContrato.empresa ? datosContrato.empresa : '--'}}
                v-list-item.px-0(v-if="ticket.numero")
                  v-list-item-content.py-0
                    v-list-item-subtitle  Tipo
                    v-list-item-title.font-weight-700(:class="{'error--text' : !datosContrato.descripcionTipoContrato}") {{datosContrato.descripcionTipoContrato ? datosContrato.descripcionTipoContrato : '--'}}
                v-list-item.px-0
                  v-list-item-content.py-0
                    v-list-item-subtitle  Vigencia
                    v-list-item-title.font-weight-700 {{datosContrato.fechaDesde | formatoFecha}} - {{datosContrato.fechaHasta | formatoFecha}}
                v-list-item.px-0
                  v-list-item-content.py-0
                    v-list-item-subtitle  ¿Incluye papel?
                    v-list-item-title.font-weight-700 {{datosContrato.incluyePapel ? 'Si incluye' : 'No incluye'}}
          v-expansion-panel(key='tecnico', v-if="ticket.codigoTecnico && perfil === 'usuario-contrato'")
            v-expansion-panel-header.pa-2
              strong.font-weight-700
                .d-flex.ai-center
                  v-icon.mr-2.primary-color perm_identity
                  small Tecnico asignado para su atención
            v-expansion-panel-content
              v-list-item.px-0
                  v-list-item-avatar
                    v-icon.background
                      | perm_identity
                  v-list-item-content.py-0
                    v-list-item-title.uppercase.bold.is-bold
                      strong {{ticket.nombreTecnico}}
                    v-list-item-subtitle.font-size-12.font-weight-700 Tecnico de campo
              v-list-item.px-0(v-if="datosTecnico")
                v-list-item-content
                  //- span {{datosTecnico}}
                  v-btn(color="info", :small="!isMovil"  @click="fetchDescargarSCTR()")
                    v-icon.mr-3  get_app
                    | Descarga SCTR
      v-col(
        cols="12"
        :md="perfil !== 'usuario-contrato' && perfil !== 'usuario' && ticket.abierto ? '6' : '8'",
        v-if="!isMovil || isMovil && tabActive === 2"
      )
        v-card.elevation-1
          .content-time-line(
            v-scroll.self="onScroll",
            id="scrolling-time-line",
            :class="{ 'is-movil-time-line': isMovil && ticket.abierto, 'is-closed-desktop' : !isMovil && !ticket.abierto, 'is-closed-movil'   : isMovil && !ticket.abierto }"
          )
            v-chip.animated.fadeInDown.faster.count(color='primary' v-if='fechaUltimaActividad', :class="!isMovil ? 'left-45' : ''")
              small.font-weight-700 {{fechaUltimaActividad}}
            time-line-actividades(
              v-if="ticket.numero"
              :numero="ticket.numero"
              ref="activity",
              @updated="obtenerFechaUltimaActividad"
            )
            .floating(v-if="ticket.numero")
              v-btn.mr-2.animated.fadeInUp.faster(small, v-if="scrollInvoked > 1000" fab color="ligth" @click="scrollToTop()")
                v-icon  keyboard_arrow_up
              v-menu(transition='slide-x-transition' bottom='' right='')
                template(v-slot:activator='{ on, attrs }')
                  v-btn.animated.fadeInUp.faster(small, fab color="primary" v-bind='attrs' v-on='on')
                    v-icon  more_vert
                v-list(dense)
                  v-list-item(@click="$refs.activity.fetchActividades(true)")
                    v-list-item-title
                      | Actualizar listado de actividades
                  v-list-item(@click="isModalAsignacionZona = true", v-if="(perfil === 'dispatcher' || perfil === 'recepcion')  && ticket.tipoticket === 'garantia'")
                    v-list-item-title
                      | Delimitacion de zona garantia
          enviar-mensaje-para-actividad(
            @send="fetchInsertarActividad",
            v-if="ticket.abierto && !isLoadingGetUser",
            ref="enviarMensaje",
            :numero="numero",
            :numero-telefono-cliente="cliente.telefono ? +cliente.telefono : 0",
            :agente="usuarioSeleccionado"
            @update-time-line="$refs.activity.fetchActividades()"
            :disabled="perfil === 'supervisor'"
          )
      v-col(
        cols="12"
        md='3',
        v-if="(!isMovil && perfil !== 'usuario-contrato' && perfil !== 'usuario'  && ticket.abierto) || (isMovil && perfil !== 'usuario-contrato' && perfil !== 'usuario' && ticket.abierto && tabActive === 3) "
      )
        .d-flex
          .flex-1.mb-3(v-if="ticket.numero && !ticket.numeroInformeTecnico && perfil !== 'usuario-contrato' && ticket.abierto")
            v-btn.width-full(
              color="primary"
              @click="openModalIntegracion(ticket.tipoticket === 'garantia' ? 18 : 2 )"
              :small="!isMovil"
              :disabled="perfil === 'supervisor'"
            )
              v-icon.mr-1  link
              | {{ticket.tipoticket === 'garantia' ? 'Recepción' : 'Integrar'}}
          .flex-1.ml-2.mb-3(v-if="ticket.tipoticket === 'garantia' && ticket.numero && !ticket.numeroInformeTecnico && perfil !== 'usuario-contrato' && perfil !== 'usuario-contrato' && ticket.abierto")
            v-btn.width-full(
              color="primary"
              @click="openModalIntegracion(33)"
              :small="!isMovil"
              :disabled="perfil === 'supervisor'"
            )
              | Soporte linea
        .flex-1.mb-3(v-if="ticket.tipoticket === 'garantia' && !ticket.idCita && ordenDelEstadodelTicket && ordenDelEstadodelTicket < ordenEstadoIngresadoTaller")
          v-btn.width-full(
            color="info"
            @click="isModalEditarCita = true"
            :small="!isMovil"
            :disabled="perfil === 'supervisor'"
          )
            v-icon.mr-1  date_range
            | Programar una cita
        v-expansion-panels(v-model='panel2' multiple='')
          v-expansion-panel(key='usuarios')
            v-expansion-panel-header.pa-2
              v-skeleton-loader(v-if="!ticket.numero" type='list-item')
              strong.font-weight-700(v-else)
                .d-flex.ai-center
                  v-icon.mr-2.primary-color group
                  span.font-size-12 Agente en atención
            v-expansion-panel-content
              v-card.box-agentes.elevation-0(:disabled="perfil === 'supervisor'")
                usuario-seleccionar(
                  :username="usuarioSeleccionado",
                  :perfiles="['dispatcher', 'recepcion']"
                  @user-selected="obtenerUsuarioSeleccionado",
                  modo-lista
                )
          v-expansion-panel(key='tickets_relacionados' v-if="ticketsRelacionados.length")
            v-expansion-panel-header.pa-2
              v-skeleton-loader(v-if="!ticket.numero" type='list-item')
              strong.font-weight-700(v-else)
                .d-flex.ai-center
                  v-icon.mr-2.primary-color style
                  span.font-size-12 Tickets relacionados
            v-expansion-panel-content
              v-card.elevation-0(width="520")
                .d-flex(v-for="(tk, index) in ticketsRelacionados" :key="index")
                  ticket-summary-info.animated.fadeInUp.faster(
                    :key="tk.numero"
                    :ticket="tk"
                    :is-chart="true"
                    :show-numero-informe="true"
                    @goTo="goTo"
                  )
          v-expansion-panel.animated.slideInRight.faster(key='zona', v-show="ticket.tipoticket === 'garantia' && ticket.estado <= 2")
            v-expansion-panel-header.pa-2
              v-skeleton-loader(v-if="!ticket.numero" type='list-item')
              strong.font-weight-700(v-else)
                .d-flex.ai-center
                  v-icon.mr-2.primary-color cancel
                  span.font-size-12 Programar autoanulación por inactividad
            v-expansion-panel-content
              v-skeleton-loader(v-if="!ticket.numero" type='list-item-avatar-two-line')
              v-select(
                dense
                v-model='ticket.diasParaAutoAnulacion'
                v-else
                :items='Array.from({ length: 20 }, (_, i) => i + 1)'
                :label="`Anulacion automaticamente en ${ticket.diasParaAutoAnulacion ? ticket.diasParaAutoAnulacion : '?'} dias`"
                persistent-hint=''
                @change="fetchActualizaDiasAutoAnulacion"
                :disabled="isLoadingChangeDiasAutoAnulacion || perfil === 'supervisor'"
                hide-details
              )
                template(slot='item' slot-scope='data')
                  small.font-weight-700 {{ data.item }} {{data.item > 1 ? 'días' : 'día'}}
              v-alert.mt-3.mb-0(  text='' type='info'  dense)
                small.font-size-11.mt-2
                  span El ticket se anulará automaticamente
                  span &nbsp;  si permanece en estado
                  span.info--text.font-weight-700  &nbsp; "Registrado" o "Revisado por agente"
                  span &nbsp; y no hay actividad en los proximos {{ticket.diasParaAutoAnulacion}} dias
              small.font-weight-700 Fecha autoanulación : {{fechaProbableAnulacionAutomatica}}
          v-expansion-panel.animated.slideInRight.faster(key='responsable', v-show="ticket.tipoticket === 'garantia' && perfil !== 'usuario'")
            v-expansion-panel-header.pa-2
              v-skeleton-loader(v-if="!ticket.numero" type='list-item')
              strong.font-weight-700(v-else)
                .d-flex.ai-center
                  v-icon.mr-2.primary-color person
                  span.font-size-12 Responsable de la garantia
            v-expansion-panel-content
              .flex-1(v-if="ticket.tipoticket === 'garantia'")
                v-select(
                  dense
                  v-model='ticket.responsableGarantia'
                  :items='responsablesGarantia'
                  label="Responsable garantia"
                  item-text="name"
                  item-value="id"
                )
              .flex-1(v-if="ticket.tipoticket === 'garantia' && ticket.responsableGarantia === 'marca'")
                v-text-field(   v-model='ticket.numeroNotaCreditoGarantia' dense  type="text" label='Numero de nota de credito ' )
              .flex-1.d-flex.mb-3(:class="isMovil && 'fd-column'" v-if="ticket.tipoticket === 'garantia' ")
                v-btn.flex-1.me-2(  @click="fecthGuardarDatosResponsableGarantia()" small='' color='success')
                  v-icon
                    | save
                  small Guardar cambios
              .flex-1.d-flex(:class="isMovil && 'fd-column'" v-if="ticket.tipoticket === 'garantia' ")
                v-btn.flex-1.me-2(v-if="ticket.urlDocumentoSustentoGarantia"  @click="goToFileSustento()" small='' color='info')
                  v-icon
                    | link
                  small Ver sustento
                v-btn.flex-1(  @click="isUploadFiles = true" small='' color='primary' v-if="ticket.responsableGarantia !== 'ninguno'")
                  v-icon
                    | attach_file
                  small Adjuntar sustento
          v-expansion-panel(key='ticket')
            v-expansion-panel-header.pa-2
              v-skeleton-loader(v-if="!ticket.numero" type='list-item')
              strong.font-weight-700(v-else)
                .d-flex.ai-center
                  v-icon.mr-2.primary-color linear_scale
                  span.font-size-12 Seguimiento de etapas
            v-expansion-panel-content
              v-card.elevation-0(:disabled="perfil === 'supervisor'")
                .d-flex.flex-wrap
                  .flex-1.mx-1
                    v-menu(v-model='showPopoverFechasEstado' :close-on-content-click='false'  offset-x='')
                      template(v-slot:activator='{ on, attrs }')
                        v-btn.mb-3(
                          color="primary"
                          @click="fetchVerificarfechasCambioEstado()"
                          v-bind='attrs' v-on='on'
                          :small="!isMovil"
                          block
                        )
                          v-icon.mr-1  history_toggle_off
                          | Hist. estados
                      v-card.overflow-y-auto(width="380" max-height="500" )
                        v-list.py-0(dense, v-for="(f, index) in fechasCambioEstado" :key="index" )
                          v-list-item
                            v-list-item-content.py-0
                              v-list-item-title.font-size-12.font-weight-700
                                .d-flex.fd-column
                                  .flex-1
                                    span
                                      v-icon(size="13" color="success") east
                                      span.mx-2 {{f.nuevo}}
                                  .flex-1
                                    span
                                      v-icon(size="13" color="error") west
                                      span.mx-2 {{f.anterior}}
                              v-list-item-subtitle.font-size-11
                                .d-flex
                                  span {{f.now}} - {{f.fecha}}
                                  v-spacer
                                  span {{f.usuario}}
                  .flex-1.mx-1
                    v-menu(v-model='showPopoverFechasEtapa' :close-on-content-click='false'  offset-x='')
                      template(v-slot:activator='{ on, attrs }')
                        v-btn.mb-3(
                          color="primary"
                          @click="fetchVerificarfechasCambioEtapa()"
                          v-bind='attrs' v-on='on'
                          :small="!isMovil"
                          block
                        )
                          v-icon.mr-1  history_toggle_off
                          | Hist. etapas
                      v-card.overflow-y-auto(width="380" max-height="500" )
                        v-list.py-0(dense, v-for="(f, index) in fechasCambioEtapas" :key="index" )
                          v-list-item
                            v-list-item-content.py-0
                              v-list-item-title.font-size-12.font-weight-700
                                .d-flex.fd-column
                                  .flex-1
                                    span
                                      v-icon(size="13" color="success") east
                                      span.mx-2 {{f.nuevo}}
                                  .flex-1
                                    span
                                      v-icon(size="13" color="error") west
                                      span.mx-2 {{f.anterior}}
                              v-list-item-subtitle.font-size-11
                                .d-flex
                                  span {{f.now}} - {{f.fecha}}
                                  v-spacer
                                  span {{f.usuario}}
                v-stepper.elevation-0.pb-0(v-model='indexEtapaSeleccionada' vertical='' dense :disabled="isLoadingEtapas")
                  template(v-for='(n, index) in listaEtapas')
                    v-stepper-step.cursor-step.pt-2.pb-1.pl-1(
                      :class="n.id < ticket.etapaEstado && 'pointer-events'"
                      dense,
                      :step='n.id'
                      :key='`${n.id}-step`'
                      :complete='indexEtapaSeleccionada > n.id'
                      @click.native="indexEtapaSeleccionada = n.id"
                      :color="indexEtapaSeleccionada > n.id ? 'success' : 'primary'"
                    )
                      small.font-weight-700 {{n.descripcion}}
                      small.font-weight-700.font-size-10.success--text(v-if="n.id < ticket.etapaEstado") etapa cerrada
                    v-stepper-content.pa-3.ml-4(:step='n.id', :key='`${n.id}-step-content`' )
                      estados-ticket(
                        :tipo="ticket.tipoticket",
                        :codigo="ticket.estado",
                        :etapa="n.id"
                        @selected="obtenerEstado",
                        v-if="renderComponentEstados"
                      )
                .mt-8(v-if="ticket.tipoticket === 'garantia'")
                  v-select(:items="['propio', 'tercerizado']" label='¿A que taller ingreso el equipo?' dense='' v-model="ticket.tipoTallerIngresado"  hide-details @change="fetchActualizarTipoTallerIngresado()")
                .mt-6(v-if="ticket.tipoticket === 'garantia'")
                  v-switch.py-0.my-0(v-model='ticket.esCobrable' dense label="¿Es servicio cobrable?"  :value="1" hide-details)

          v-expansion-panel(key='equipo_cambiar', v-if="ticket.tipoticket === 'garantia'")
            v-expansion-panel-header.pa-2
              v-skeleton-loader(v-if="!ticket.numero" type='list-item')
              strong.font-weight-700(v-else)
                .d-flex.ai-center
                  v-icon.mr-2.primary-color print
                  span.font-size-12 Actualización de datos de equipo
            v-expansion-panel-content
              v-skeleton-loader(v-if="!ticket.numero" type='list-item-avatar-two-line')
              v-card.elevation-0(v-else, :disabled="perfil === 'supervisor'")
                v-alert.mb-6(  text='' :type="ticket.sigueEnGarantia ? 'success' : 'error'" v-if="ticket.tipoticket === 'garantia' && ticket.comproAqui" dense)
                  small.font-size-11 Al registrarse el ticket el usuario indico que el equipo {{ticket.sigueEnGarantia ? 'todavia se encuentra ' : 'ya no se encuentra '}} en garantía
                .flex-1(v-if="ticket.tipoticket === 'garantia'")
                  v-text-field(  v-model='ticket.serie' dense  type="text" label='Ingrese la serie del equipo ' )
                    template(v-slot:append='')
                      v-btn.mb-2(x-small, fab color="info", @click="showModalDataSerie = true")
                        v-icon  visibility
                .d-flex(:class="isMovil && 'fd-column'")
                  .flex-1(v-if="ticket.tipoticket === 'garantia'")
                    v-select(
                      dense
                      v-model='ticket.marca'
                      :items='marcas'
                      label="Seleccionar marca"
                      item-text="descripcion"
                      item-value="descripcion"
                      hide-details
                    )
                  .flex-1(:class="!isMovil && 'px-6'" v-if="ticket.tipoticket === 'garantia'")
                    v-text-field(   v-model='ticket.modelo' dense  type="text" label='Ingrese el modelo del equipo ' )
            v-expansion-panel-header.pa-2
              v-skeleton-loader(v-if="!ticket.numero" type='list-item')
              strong.font-weight-700(v-else)
                .d-flex.ai-center
                  v-icon.mr-2.primary-color style
                  span.font-size-12 Permisos para documentos de tecnico
            v-expansion-panel-content
              v-card.elevation-0(width="520")
                .d-flex.ai-center(v-for='(item, i) in tiposDocumentos')
                  v-checkbox.ma-0(v-model='item.active' :name="item.code"  :id="item.code" color='primary'  hide-details )
                  label.font-size-11(:class="{'!primary--text font-weight-700' : item.active}" :for="item.code") {{ item.name}}
          v-btn.mt-3(block color="success", :disabled="!ticket.abierto || perfil === 'supervisor'"  :small="!isMovil"  @click="openModalAddMessage()")
            | Confirmar cambios

</template>

<script>
import moment                      from 'moment'
// import Router                      from '../router/customer.js'
import RouterDispatcher            from '../router/dispatcher.js'
import timeLineActividades         from '@/components/c_timeline_actividades_ticket'
import enviarMensajeParaActividad  from '@/components/c_enviar_mensaje_para_actividades'
import usuariosSeleccionar         from '@/components/c_usuarios_lista_seleccionar'
import itemUsuario                 from '@/components/c_card_informacion_usuario'
import estadosTicket               from '@/components/c_estados_tickets'
import itemSerie                   from '@/components/c_card_informacion_serie'
import formCita                    from '@/components/c_card_form_programacion_cita'
import lookupTickets               from '@/components/c_listado_tickets_seleccionar'
import lookupDirecciones               from '@/components/c_direcciones_cliente_seleccionar'
import TicketSummaryInfo  from '@/components/c_item_ticket_lista'
import adjuntarArchivos from '@/components/c_adjuntar_archivos'

import { apiGet, apiPost, notify, apiUploadWithParams } from '../util/general'
export default {
  name : 'View_detalle_ticket',
  props: {
    numero : {
      type   : String,
      default: ''
    }
  },
  components: {
    'time-line-actividades'           : timeLineActividades,
    'enviar-mensaje-para-actividad'   : enviarMensajeParaActividad,
    'usuario-seleccionar'             : usuariosSeleccionar,
    'item-usuario'                    : itemUsuario,
    'estados-ticket'                  : estadosTicket,
    'item-serie'                      : itemSerie,
    'form-cita'                       : formCita,
    'listado-tickets-seleccionar'     : lookupTickets,
    'listado-direcciones-seleccionar' : lookupDirecciones,
    'ticket-summary-info'             : TicketSummaryInfo,
    'adjuntar-archivos' : adjuntarArchivos
  },
  data () {
    return {
      tiposDocumentos : [
        {
          code: 'dni',
          name: 'DNI',
          active: true
        },
        {
          code: 'permisos de vuelo de drone',
          name: 'PERMISOS DE VUELO DE DRONE',
          active: true
        },
        {
          code: 'tarjeta de vacunacion',
          name: 'TARJETA DE VACUNACION',
          active: true
        },
        {
          code: 'sctr',
          name: 'SCRT',
          active: true
        }
      ],
      perfil                          : localStorage.getItem('perfil'),
      panel                           : [2, 0, 1, 2, 3, 4, 5],
      panel2                          : [3, 4, 5, 6],
      ticket                          : {},
      comentario                      : '',
      codigoTecnico                   : '',
      cliente                         : {},
      usuarioSeleccionado             : localStorage.getItem('username'),
      fechaUltimaActividad            : '',
      isModalAnularTicket             : false,
      comentarioParaAnular            : '',
      scrollInvoked                   : 0,
      tienePermisos                   : false,
      showModalFacturasAsociadas                   : false,
      isLoadingFacturasAsociados                   : false,
      empresaFacturasAsociadas                     : process.env.EMPRESA,
      tabActive                       : 1,
      isAddMessageChanges             : false,
      comentarioChanges               : '',
      showModalDataSerie              : false,
      isModalIntegracion              : false,
      isLoadingChangeTipoArea         : false,
      isLoadingChangeZonaGarantia     : false,
      isLoadingChangeDiasAutoAnulacion: false,
      fechaProbableAnulacionAutomatica: '',
      tabAcciones                     : 0,
      tipoIntegracion                 : 1,
      isModalEditarCita               : false,
      datosCita                       : {},
      ordenEstadoIngresadoTaller      : 4,
      ordenDelEstadodelTicket         : 0,
      isCreacionExterno               : false,
      renderComponentEstados          : true,
      showInfoUser                    : false,
      showPopoverFechasEstado         : false,
      showPopoverFechasEtapa          : false,
      isGettingFallas          : false,
      fechasCambioEstado              : [],
      fechasCambioEtapas              : [],
      ubigeos              : [],
      departamentos              : [],
      fallas              : [],
      marcas                          : [],
      listaEtapas                    : [],
      dataFacturasAsociadas                    : [],
      indexEtapaSeleccionada          : 0,
      apiUpload                       : process.env.API_UPLOAD_ROUTE,
      apiRouteSist                    : process.env.SIST_WEB_ROUTE,
      empresa                         : process.env.EMPRESA,
      isModalAsignacionZona           : false,
      isLoadingEtapas                 : false,
      isLoadingGetUser                 : false,
      isLoadingGetSerie                 : false,
      isLoadingUbigeos                 : false,
      datosContrato : {},
      datosSerieInforme : {
        serie : '',
        direccion : '',
        idDireccion : '',
        ubigeo : '',
        descripcionUbigeo : '',
        extra : '',
        telefono : '',
        email : '',
        codigoClienteSap : 0,
        contacto : '',
        codigoFalla : 100000,
        descripcionFalla : 'OTROS'
      },
      ticketsRelacionados : [],
      datosTecnico : null,
      fallaSeleccionada : {
        codigoFallaGeneral : 100000,
        descripcionFallaGeneral : 'OTROS'
      },
      ubigeoSeleccionado : {
        ubigeo : '',
        descripcion : ''
      },
      direccionSeleccionado : {
        id : '',
        direccion : ''
      },
      isUploadFiles : false,
      isGenerarITGarantia : false,
      seriesRepetidas : [],
      responsablesGarantia : [
        {id: 'ninguno', name: 'Ninguno'},
        {id: 'empresa', name: 'Empresa'},
        {id: 'marca', name: 'Marca'}
      ],
      tiposInforme : [
        { id: 'emergencia', name: '1 - Emergencia', code: 1, ticket_type: ['incidencia con equipo'] },
        { id: 'preventivo', name: '2 - Preventivo', code: 2, ticket_type: ['incidencia con equipo'] },
        { id: 'toner', name: '7 - Toner', code: 7, ticket_type: ['solicitud de insumo'] },
        { id: 'software_config', name: '11 - Configuracion de Software', code: 11, ticket_type: ['incidencia con equipo'] },
        { id: 'instalacion_repuestos', name: '20 - Instalacion Repuestos', code: 20, ticket_type: ['incidencia con equipo'] },
        { id: 'configuracion_equipo', name: '44 - Configuracion de Equipo', code: 44, ticket_type: ['incidencia con equipo'] },
        { id: 'desinstalacion_equipo', name: '13 - Desinstalacion de Equipo', code: 13, ticket_type: ['incidencia con equipo'] },
        { id: 'instalacion', name: '3 - Instalacion', code: 3, ticket_type: ['incidencia con equipo'] },
        { id: 'revision', name: '24 - Revision', code: 24, ticket_type: ['incidencia con equipo'] },
        { id: 'reparacion', name: '5 - Reparacion', code: 5, ticket_type: ['incidencia con equipo'] },
        { id: 'papel', name: '8 - Papel', code: 8, ticket_type: ['solicitud de insumo'] },
        { id: 'apoyo_tecnico', name: '42 - Apoyo Tecnico', code: 42, ticket_type: ['incidencia con equipo'] },
        { id: 'supervision', name: '17 - Supervision', code: 17, ticket_type: ['incidencia con equipo'] },
        { id: 'soporte_en_linea', name: '33 - Soporte en Linea', code: 33, ticket_type: ['garantia'] },
        { id: 'entrega_cafe', name: '35 - Entrega de Cafe', code: 35, ticket_type: ['solicitud de insumo'] },
        { id: 'traslado_repuestos', name: '41 - Traslado o Recojo de Repuestos', code: 41, ticket_type: ['incidencia con equipo'] },
        { id: 'retiro_repuestos', name: '27 - Retiro de Repuestos', code: 27, ticket_type: ['incidencia con equipo'] },
        { id: 'preparacion', name: '4 - Preparacion', code: 4, ticket_type: ['incidencia con equipo'] },
        { id: 'recepcion_equipo', name: '18 - Recepcion Equipo', code: 18, ticket_type: ['garantia'] },
        { id: 'mantenimiento', name: '25 - Mantenimiento', code: 25, ticket_type: ['incidencia con equipo'] },
        { id: 'inspeccion', name: '12 - Inspeccion', code: 12, ticket_type: ['incidencia con equipo'] },
        { id: 'traslado_equipo', name: '14 - Traslado de Equipo', code: 14, ticket_type: ['incidencia con equipo'] },
        { id: 'instalacion_software', name: '32 - Instalacion Software', code: 32, ticket_type: ['incidencia con equipo'] },
        { id: 'regularizacion_doc', name: '21 - Regularizacion Documentaria', code: 21, ticket_type: ['incidencia con equipo'] },
        { id: 'termino_contrato', name: '34 - Termino de Contrato', code: 34, ticket_type: ['incidencia con equipo'] }
      ]
    }
  },
  created () {
    var vm = this
    vm.fetchCheckPermisos((err, data) => {
      if (err) {
        notify(vm, 'error', 'Error', 'No tiene perfil definido')
        RouterDispatcher.push('/tickets')
        RouterDispatcher.go()
        return
      }

      vm.tienePermisos = data.tienePermisos
      if (data.tienePermisos) {
        vm.fetch()
      } else {
        notify(vm, 'error', 'Error', 'No tienes permisos para visualizar los datos de este ticket')
        RouterDispatcher.push('/tickets')
        RouterDispatcher.go()
      }
    })

    vm.fetchGetDataParametros((err, parametros) => {
      if (err) {
        notify(vm, 'error', 'Error', err.message)
      } else {
        vm.ordenEstadoIngresadoTaller = parametros.ordenEstadoIngresadoTaller
      }
    })
    vm.fetchGetDataMarcas()
  },
  computed : {
    isMovil () {
      var vm = this
      return vm.$vuetify.breakpoint.smAndDown
    },
    tiposInformeFiltrado () {
      var vm = this
      return vm.tiposInforme.filter(e => e.ticket_type.includes(vm.ticket.tipoticket))
    }
  },
  filters : {
    now : function (val) {
      return moment(val).fromNow()
    },
    formatoFecha: function (value) {
      if (!value) return ''
      return moment.utc(value).format('DD/MM/YYYY')
    }
  },
  methods: {
    goToFileSustento () {
      var vm = this
      window.open(vm.ticket.urlDocumentoSustentoGarantia, '_blank')
    },
    setFilesToSave (files = []) {
      var vm = this
      vm.$store.dispatch('transaccionForce', { force : true, message : `Adjuntando sustento` })
      vm.uploadFile(files[0], async (err, response) => {
        if (err) {
          notify(vm, 'error', 'Error', err.message)
          vm.$store.dispatch('transaccionForce', { force : false })
        } else {
          console.log('response', response)
          vm.ticket.urlDocumentoSustentoGarantia = response.ruta
          vm.fecthGuardarDatosResponsableGarantia(function (err) {
            if (err) {
              notify(vm, 'error', 'Error', err.message)
              vm.$store.dispatch('transaccionForce', { force : false })
              return
            }

            notify(vm, 'success', 'Exito', 'Los cambios se guardarón correctamente')
            vm.closeModalAdjuntar()
            vm.$store.dispatch('transaccionForce', { force : false })
          })
        }
      })
    },
    uploadFile (file, callback) {
      var vm = this
      var fd = new FormData()
      var apiUploadRoute = process.env.API_UPLOAD_ROUTE
      var url = `${apiUploadRoute}/upload`
      fd.append('file', file)
      var params = {
        carpeta: 'actividades',
        usuario: vm.usuarioSeleccionado
      }

      apiUploadWithParams(vm, url, fd, params,  res => {
        callback(null, res)
      }, err => {
        callback(err)
      })
    },
    fecthGuardarDatosResponsableGarantia (callback) {
      var vm  = this
      var obj = {
        numero : vm.ticket.numero,
        responsableGarantia : vm.ticket.responsableGarantia,
        numeroNotaCreditoGarantia : vm.ticket.numeroNotaCreditoGarantia,
        urlDocumentoSustentoGarantia : vm.ticket.urlDocumentoSustentoGarantia
      }
      apiPost(vm, '/ticket/actualizar/datos/garantia', obj, function (data) {
        if (callback)  callback()
        else {
          notify(vm, 'success', 'Exito', 'Los cambios se guardarón correctamente')
        }
      }, function (err) {
        if (callback)  callback(err)
        else {
          notify(vm, 'error', 'Error', err.message)
        }
      })
    },
    closeModalAdjuntar () {
      var vm = this
      vm.isUploadFiles = false
    },
    fetchTicketsRelacionados () {
      var vm  = this
      var url = ''
      var obj = {}
      url = '/ticket/obtener/relacionados'
      obj = {
        numeroTicket : vm.ticket.numero,
        numeroTicketBase : vm.ticket.numeroTicketBase
      }
      if (!url) {
        notify(vm, 'error', 'Error', 'Los parametros enviados no son validos')
        return
      }
      apiGet(vm, url, obj, function (data) {
        vm.ticketsRelacionados = data.lista
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, function () {
      })
    },
    goToHistoriaTecnica () {
      var vm  = this
      var url = `${vm.apiRouteSist}/#/historia-tecnica/${vm.ticket.serie}`
      window.open(url, '_blank')
    },
    goToPdfFacturaAsociada (pdfUrl) {
      window.open(pdfUrl, '_blank')
    },
    fetchGetContrato (numeroContrato) {
      var vm  = this
      var obj = {
        octopus: true,
        filtro : numeroContrato
      }
      apiGet(vm, '/contrato/obtener', obj, function (data) {
        console.log('data.lista', data.lista)
        if (data.lista.length) {
          vm.datosContrato = data.lista[0]
        }
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      })
    },
    fetchGetSerie () {
      var vm = this
      vm.isLoadingGetSerie = true
      var obj = {
        serie: vm.ticket.serie,
        tipoTicket : vm.ticket.tipoticket
      }
      apiGet(vm, '/integracion/serie/obtener', obj, function (data) {
        var serie = data.data
        console.log('serie', serie)
        vm.datosSerieInforme.serie = serie.serie
        vm.datosSerieInforme.extra = serie.extra
        vm.datosSerieInforme.telefono = serie.telefono
        vm.datosSerieInforme.email = serie.emailS
        vm.datosSerieInforme.contacto = serie.atencion
        vm.datosSerieInforme.codigoClienteSap = serie.codigoClienteSap
        vm.ubigeoSeleccionado.ubigeo = serie.ubigeo
        vm.ubigeoSeleccionado.descripcion = serie.descripcionUbigeo
        vm.direccionSeleccionado.id = serie.idDireccion
        vm.direccionSeleccionado.direccion = serie.direccion
        vm.direccionSeleccionado.observacion = ''
        var tipoProductoMaquina  = serie.codigoArticuloNuevo ? serie.codigoArticuloNuevo.substring(0, 2) : ''
        vm.fetchFallas(tipoProductoMaquina)
        vm.fetchUbigeos(err => {
          if (err) notify(vm, 'error', 'Error', err.message)
        })
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, () => {
        vm.isLoadingGetSerie = false
      })
    },
    openInformeDeRecepcion () {
      var vm = this
      window.open(vm.ticket.urlGuiaRecepcionFirmada, '_blank')
    },
    fetchGetDataEtapasEstados () {
      var vm  = this
      vm.isLoadingEtapas = true
      vm.listaEtapas = []
      var obj = {
        tipo : vm.ticket.tipoticket
      }
      apiGet(vm, '/estado/obtener/etapas', obj, function (data) {
        for (let i = 0; i < data.lista.length; i++) {
          const element = data.lista[i];
          vm.listaEtapas.push({
            id : element.codigo,
            descripcion : element.descripcion,
            tipoEstado : element.tipoEstado
          })
        }
        vm.$nextTick(() => {
          vm.indexEtapaSeleccionada = vm.ticket.etapaEstado
        })
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, () => {
        vm.isLoadingEtapas = false
      })
    },
    fetchGetDataMarcas () {
      var vm  = this
      var obj = {
        octopus: true
      }
      apiGet(vm, '/articulo/marca-articulo', obj, function (data) {
        vm.marcas = data.lista
        console.log('marcas', vm.marcas)
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      })
    },
    fetchGetDataParametros (callback) {
      var vm = this
      var obj      = {}
      apiGet(vm, '/parametro/obtener', obj, function (data) {
        callback(null, data.lista[0])
      }, function (error) {
        callback(error)
      })
    },
    openModalIntegracion (tipo) {
      var vm = this
      vm.tipoIntegracion = tipo
      var tipos = vm.tiposInforme.find(e => e.code === tipo)
      if (!tipos) {
        notify(vm, 'error', 'Error', 'El codigo de tipo de IT no existe')
        return
      }
      vm.isGenerarITGarantia = tipos.ticket_type.includes('garantia')
      vm.isModalIntegracion = true
      !vm.isGenerarITGarantia && vm.fetchGetSerie()
    },
    closeModalDataSerie () {
      var vm = this
      vm.showModalDataSerie = false
    },
    closeModalFacturasAsociadas () {
      var vm = this
      vm.showModalFacturasAsociadas = false
    },
    openModalFacturasAsociadas () {
      var vm = this
      vm.showModalFacturasAsociadas = true
      vm.fetchFacturasAsociadas()
    },
    fetchFacturasAsociadas () {
      var vm = this
      vm.isLoadingFacturasAsociados = true
      vm.dataFacturasAsociadas      = []
      var url      = '/factura/serie-maquina-factura'
      var obj      = {
        serie        : vm.ticket.serie,
        empresaManual: vm.empresaFacturasAsociadas,
        octopus      : true
      }
      apiGet(vm, url, obj, function (data) {
        console.log('data serie maquina factura:', data)
        for (var i = 0; i < data.lista.length; i++) {
          vm.dataFacturasAsociadas.push(data.lista[i])
        }
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.isLoadingFacturasAsociados = false
      })
    },
    obtenerUsuarioSeleccionado (usuario) {
      var vm = this
      vm.usuarioSeleccionado = usuario.usuario
    },
    getDireccion (direccion) {
      var vm = this
      vm.direccionSeleccionado.id = direccion.id
      vm.direccionSeleccionado.direccion = direccion.direccion
      vm.ubigeoSeleccionado.ubigeo = direccion.ubigeo
      var ubigeo = vm.ubigeos.filter(e => e.ubigeo === direccion.ubigeo)
      if (!ubigeo.length) return notify(vm, 'error', 'Error', 'El codigo de ubigeo de ka direccion no existe')
      vm.ubigeoSeleccionado.descripcion = ubigeo[0].descripcion
    },
    openModalAddMessage () {
      var vm = this
      vm.isAddMessageChanges = true
    },
    closeModalAddMessage () {
      var vm = this
      vm.isAddMessageChanges = false
      vm.comentarioChanges = ''
    },
    goTo (page) {
      RouterDispatcher.push(page)
    },
    fetchCheckPermisos (callback) {
      var vm = this
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Verificando permisos' })
      var url = 'ticket/verificar/permiso'
      var obj = {
        numero: vm.numero
      }
      apiGet(vm, url, obj, function (data) {
        callback(null, data)
      }, function (err) {
        callback(err)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    fetchVerificarfechasCambioEstado () {
      var vm = this
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Verificando fechas de cambio' })
      var url = 'ticket/obtener/fecha/estados'
      var obj = {
        numero: vm.numero
      }
      apiGet(vm, url, obj, function (data) {
        console.log('data', data)
        vm.fechasCambioEstado = data.data
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    fetchVerificarfechasCambioEtapa () {
      var vm = this
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Verificando fechas de cambio' })
      var url = 'ticket/obtener/fecha/etapas'
      var obj = {
        numero: vm.numero
      }
      apiGet(vm, url, obj, function (data) {
        console.log('data', data)
        vm.fechasCambioEtapas = data.data
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    onScroll (e) {
      var vm = this
      vm.scrollInvoked = e.target.scrollTop
    },
    scrollToTop () {
      document.getElementById('scrolling-time-line').scrollTop = 0
    },
    closeModalAnular () {
      var vm = this
      vm.comentarioParaAnular = ''
      vm.isModalAnularTicket = false
    },
    fetchCloseTicket () {
      var vm = this
      if (!vm.comentarioParaAnular) {
        notify(vm, 'error', 'Error', 'Por favor ingrese un mensaje para conocer la razón de la anulación')
        vm.$refs.comentarioParaAnular.focus()
        return;
      }

      vm.$store.dispatch('transaccion', { isProceso : true, message : `Anulando ticket ${vm.ticket.numero}` })
      var obj = {
        numero    : vm.ticket.numero,
        mensaje   : vm.comentarioParaAnular,
        tipoTicket: vm.ticket.tipoticket
      }

      apiPost(vm, '/ticket/' + vm.ticket.numero + '/anular', obj, function (data) {
        notify(vm, 'success', '', 'Ticket anulado exitosamente')
        vm.fetchCantidadTicketsAbiertos()
        vm.closeModalAnular()
        vm.fetch()
        vm.$refs.activity.fetchActividades()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    fetchIntegrarTicket () {
      var vm = this
      vm.fetchGuardarCambiosArchivoMaquinas(function (error) {
        if (error) {
          notify(vm, 'error', 'Error', error.message)
          return
        }

        vm.$store.dispatch('transaccion', { isProceso : true, message : `Integrando ticket de ${vm.ticket.tipoticket} ${vm.ticket.numero}` })
        var obj = {
          numero         : vm.ticket.numero,
          observacion : vm.datosSerieInforme.observacion,
          tipoIntegracion: vm.tipoIntegracion
        }

        apiPost(vm, '/integracion/crear/informe/tecnico', obj, function (data) {
          notify(vm, 'success', 'Éxito', ('Integrado correctamente con el numero ' + data.numeroInformeTecnico))
          vm.ticket.numeroInformeTecnico = data.numeroInformeTecnico
          if (Object.keys(data.cambios).length) {
            vm.$refs.activity.fetchActividades()
            if (data.cambios.estado) {
              vm.ticket.estado = data.cambios.estado
              vm.forceRerenderEstados()
            }
            if (data.cambios.modelo) {
              vm.ticket.modelo = data.cambios.modelo
            }
          }
        }, function (error) {
          notify(vm, 'error', 'Error', error.message)
        }, function () {
          vm.$store.dispatch('transaccion', { isProceso : false })
          vm.isModalIntegracion = false
        })
      })
    },
    fetchGuardarCambiosArchivoMaquinas (callback) {
      var vm = this
      if (vm.isGenerarITGarantia) callback(null)
      else {
        if (!vm.datosSerieInforme.serie) {
          callback({message: 'Ingrese una serie valida'})
          return
        }

        if (!vm.direccionSeleccionado.direccion || !vm.direccionSeleccionado.id) {
          callback({message: 'La serie no cuenta con una direccion valida'})
          return
        }

        if (!vm.ubigeoSeleccionado.ubigeo || !vm.ubigeoSeleccionado.descripcion) {
          callback({message: 'La serie no cuenta con un codigo de ubigeo valido'})
          return
        }

        if (!vm.datosSerieInforme.extra) {
          callback({message: 'La serie no cuenta con una ubicacion valida'})
          return
        }

        if (!vm.datosSerieInforme.telefono) {
          callback({message: 'La serie no cuenta con un telefono valido'})
          return
        }

        if (!vm.datosSerieInforme.contacto) {
          callback({message: 'La serie no cuenta con un contacto valido'})
          return
        }

        if (!vm.datosSerieInforme.email) {
          callback({message: 'El contacto no cuenta con un email valido'})
          return
        }

        if (!vm.datosSerieInforme.observacion) {
          callback({message: 'El informe no cuenta con una observacion valida'})
          return
        }

        var obj = {
          serie : vm.datosSerieInforme.serie,
          idDireccion : vm.direccionSeleccionado.id,
          direccion : vm.direccionSeleccionado.direccion,
          extra : vm.datosSerieInforme.extra,
          telefono : vm.datosSerieInforme.telefono,
          contacto : vm.datosSerieInforme.contacto,
          email : vm.datosSerieInforme.email,
          ubigeo : vm.ubigeoSeleccionado.ubigeo,
          descripcionUbigeo : vm.ubigeoSeleccionado.descripcion
        }

        apiPost(vm, '/integracion/serie/actualizar/datos', obj, function (data) {
          callback()
        }, function (error) {
          callback(error)
        })
      }
    },
    fetchFallas (tipoProductoMaquina) {
      var vm = this
      vm.isGettingFallas = true
      var obj = {
        codigoTipoEquipo: tipoProductoMaquina
      }
      apiGet(vm, '/falla/por/tipo/producto', obj, function (data) {
        vm.fallas = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isGettingFallas = false
      })
    },
    fetchUbigeos (callback) {
      var vm  = this
      vm.isLoadingUbigeos = true
      var obj = {}
      apiGet(vm, '/ubigeo/obtener', obj, function (data) {
        vm.ubigeos = data.lista
        for (var i = 0; i < data.lista.length; i++) {
          if (!vm.departamentos.includes(data.lista[i].departamento)) vm.departamentos.push(data.lista[i].departamento)
        }
        callback && callback()
      }, function (error) {
        callback ? callback(error) :  notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoadingUbigeos = false
      })
    },
    fetchDescargarSCTR () {
      var vm = this
      window.open(vm.datosTecnico.ruta, '_blanck')
    },
    getSCTRTecnico () {
      var vm  = this
      var obj = {
        octopus: true,
        tipoDocumento : 'sctr',
        codigo : vm.ticket.codigoTecnico
      }
      apiGet(vm, '/tecnico/obtenerAdjunto', obj, function (data) {
        console.log('data', data)
        if (data.lista.length) {
          vm.datosTecnico = data.lista[0]
        }
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      })
    },
    forceRerenderEstados () {
      var vm = this
      vm.renderComponentEstados = false;
      vm.$nextTick(() => {
        vm.renderComponentEstados = true;
      })
    },
    obtenerFechaUltimaActividad (fecha) {
      var vm = this
      vm.fechaUltimaActividad = moment(fecha).format('DD/MM/YYYY')
      if (vm.fechaUltimaActividad) {
        vm.fechaProbableAnulacionAutomatica =  moment.utc(vm.fechaUltimaActividad, 'DD/MM/YYYY').add(vm.ticket.diasParaAutoAnulacion, 'days').format('DD/MM/YYYY')
      }
      vm.scrollToTop()
    },
    obtenerEstado (estado) {
      var vm = this
      if (!vm.ticket.abierto) return
      vm.ticket.estado            = estado.codigo
      vm.ticket.descripcionEstado = estado.descripcion
      vm.ordenDelEstadodelTicket = estado.orden
    },
    fetch () {
      var vm = this
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obteniendo detalle de ticket' })
      var url = 'ticket/obtener'
      var obj = {
        numero: vm.numero
      }
      apiGet(vm, url, obj, function (data) {
        vm.ticket = data.lista[0]
        vm.fallaSeleccionada.codigoFallaGeneral = vm.ticket.codigoFalla   || 100000
        vm.fallaSeleccionada.descripcionFallaGeneral = vm.ticket.descripcionFalla  ||  'OTROS'
        vm.datosSerieInforme.observacion = vm.ticket.comentarioGeneral

        if (vm.ticket.insumo) {
          vm.ticket.insumo = vm.ticket.insumo.split(',')
        }

        vm.fetchGetDataUser(vm.ticket.usuario)
        if ((vm.ticket.zonaGarantia === 'sin asignacion' || vm.ticket.tipoArea === 'sin asignacion') && (vm.perfil === 'dispatcher' || vm.perfil === 'recepcion') && vm.ticket.tipoticket === 'garantia') {
          vm.isModalAsignacionZona = true
        }
        if (vm.ticket.numeroInformeTecnico) {
          vm.fetchTicketsRelacionados()
        }
        vm.seriesRepetidas = []
        vm.fetchSerieRepetida((err, data) => {
          if (err) {
            notify(vm, 'error', 'Error', err)
            return
          }
          if (data.length > 0) {
            for (var i = 0; i < data.length; i++) {
              data[i].fechaRegistro = data[i].fechaRegistro ? moment(data[i].fechaRegistro, 'YYYY-MM-DD HH:ss').format('DD/MM/YYYY HH:ss') : ''
              vm.seriesRepetidas.push({
                id: data[i].numero,
                numero: `${data[i].fechaRegistro} - ${data[i].numero}`
              })
            }
          }
          vm.fetchGetDataEtapasEstados()
          if (vm.ticket.idCita) {
            vm.fetchCita()
            vm.isCreacionExterno = true
          } else {
            vm.isCreacionExterno = false
          }
          vm.forceRerenderEstados()
          vm.ticket.codigoTecnico && vm.getSCTRTecnico()
          vm.ticket.numeroContrato && vm.fetchGetContrato(vm.ticket.numeroContrato)
        })
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    fetchGetDataUser (usuario) {
      var vm = this
      vm.isLoadingGetUser = true
      var obj      = {
        usuario : usuario
      }
      apiGet(vm, '/usuario/obtener', obj, function (data) {
        vm.cliente = data.lista[0]
        console.log('vm.cliente', vm.cliente)
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, () => {
        vm.isLoadingGetUser = false
      })
    },
    fetchSerieRepetida (callback) {
      var vm = this
      if (+vm.ticket.serieRepetida !== 1) return callback(null, [])
      var obj      = {
        serie : vm.ticket.serie,
        numero : vm.numero
      }
      apiGet(vm, '/ticket/buscar/serie/repetida', obj, function (data) {
        callback(null, data.lista)
      }, function (error) {
        callback(error)
      })
    },
    goTicket (e) {
      console.log('eeeee', e)
      window.open(`/ticket/${e}`, '_blank')
    },
    fetchInsertarActividad (comentario) {
      var vm = this
      // Validamos
      if (!comentario) {
        notify(vm, 'error', 'Error', 'Por favor ingrese un mensaje en la casilla de texto')
        return
      }

      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Enviando comentario' })
      var obj = {
        numero             : vm.ticket.numero,
        usuarioSeleccionado: vm.usuarioSeleccionado,
        mensaje            : comentario
      }

      apiPost(vm, '/ticket/registrar/actividad', obj, function (data) {
        notify(vm, 'success', 'Exito', 'Mensaje enviado exitosamente')
        vm.$refs.activity.fetchActividades()
        vm.$refs.enviarMensaje.focus()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    fetchActualizarDatosTicket () {
      var vm = this
      if (!vm.ticket.estado) {
        notify(vm, 'error', 'Error', 'Por favor seleccione un estado de la lista')
        return;
      }

      if (!vm.usuarioSeleccionado) {
        notify(vm, 'error', 'Error', 'Por favor seleccione al usuario que realiza la accion')
        return;
      }

      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Actualizando datos de ticket' })
      var obj = {
        numero             : vm.ticket.numero,
        estadoSeleccionado : vm.ticket.estado,
        codigoTecnico      : vm.ticket.codigoTecnico,
        comentario         : vm.comentarioChanges,
        usuarioSeleccionado: vm.usuarioSeleccionado,
        marca              : vm.ticket.marca,
        modelo             : vm.ticket.modelo,
        serie              : vm.ticket.serie,
        esCobrable         : vm.ticket.esCobrable,
        tipoTallerIngresado: vm.ticket.tipoTallerIngresado,
        permisosDocumentosTecnico: vm.tiposDocumentos.filter(e => e.active).map(e => e.code)
      }

      apiPost(vm, 'ticket/actualizar/datos', obj, function (data) {
        notify(vm, 'success', '', 'Accion registrada exitosamente')
        !vm.isMovil && vm.$refs.activity.fetchActividades()
        !vm.isMovil && vm.fetch()
        vm.closeModalAddMessage()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
        if (error.showModalArea) {
          vm.isModalAsignacionZona = true
        }
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    fetchActualizarTipoTallerIngresado () {
      var vm = this
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Actualizando tipo de taller ingresado' })
      var obj = {
        tipo        : vm.ticket.tipoTallerIngresado,
        numero      : vm.ticket.numero,
        zonaGarantia: vm.ticket.zonaGarantia,
        tipoArea    : vm.ticket.tipoArea
      }
      apiPost(vm, 'ticket/actualizar/tipo/taller/ingresado', obj, function (data) {
        notify(vm, 'success', '', 'cambio registrado exitosamente')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    fetchActualizarTipoArea () {
      var vm = this
      vm.isLoadingChangeTipoArea = true
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Actualizando tipo area del ticket' })
      var obj = {
        numero  : vm.ticket.numero,
        tipoArea: vm.ticket.tipoArea
      }
      apiPost(vm, 'ticket/actualizar/tipo/area', obj, function (data) {
        notify(vm, 'success', '', 'cambio registrado exitosamente')
        vm.fetchCantidadTicketsAbiertos()
        if (vm.ticket.zonaGarantia !== 'sin asignacion' && vm.ticket.tipoArea !== 'sin asignacion') {
          vm.isModalAsignacionZona = false
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
        vm.isLoadingChangeTipoArea = false
      })
    },
    fetchActualizaDiasAutoAnulacion () {
      var vm = this
      vm.isLoadingChangeDiasAutoAnulacion = true
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Actualizando dias para autoanulacion' })
      var obj = {
        numero: vm.ticket.numero,
        dias  : vm.ticket.diasParaAutoAnulacion
      }
      apiPost(vm, 'ticket/actualizar/dias/autoanulacion', obj, function (data) {
        notify(vm, 'success', '', 'cambio registrado exitosamente')
        if (vm.fechaUltimaActividad) {
          vm.fechaProbableAnulacionAutomatica =  moment.utc(vm.fechaUltimaActividad, 'DD/MM/YYYY').add(vm.ticket.diasParaAutoAnulacion, 'days').format('DD/MM/YYYY')
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
        vm.isLoadingChangeDiasAutoAnulacion = false
      })
    },
    fetchActualizaZonaGarantia () {
      var vm = this
      vm.isLoadingChangeZonaGarantia = true
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Actualizando zona  del ticket' })
      var obj = {
        numero      : vm.ticket.numero,
        zonaGarantia: vm.ticket.zonaGarantia
      }
      apiPost(vm, 'ticket/actualizar/zona/garantia', obj, function (data) {
        notify(vm, 'success', '', 'cambio registrado exitosamente')
        if (vm.ticket.zonaGarantia !== 'sin asignacion' && vm.ticket.tipoArea !== 'sin asignacion') {
          vm.isModalAsignacionZona = false
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
        vm.isLoadingChangeZonaGarantia = false
      })
    },
    fetchCantidadTicketsAbiertos (callback) {
      var vm = this
      var url = 'ticket/abiertos/count'
      var obj = {}
      apiGet(vm, url, obj, function (data) {
        var ticketsAbiertos = {}
        if (vm.perfil === 'usuario-contrato' || vm.perfil === 'usuario') {
          ticketsAbiertos.all_usuario_o_cliente = 0
        } else {
          const cantidades = data.lista[0]
          ticketsAbiertos.incidencia_con_equipo     = cantidades.ticketsAbiertosIncidenciaConEquipo
          ticketsAbiertos.solicitud_de_insumo       = cantidades.ticketsAbiertosSolicitudInsumo
          ticketsAbiertos.garantia_sin_asignar      = cantidades.ticketsAbiertosGaratiaSinAsignacion
          ticketsAbiertos.garantia_campo            = cantidades.ticketsAbiertosGarantiaCampo
          ticketsAbiertos.garantia_taller           = cantidades.ticketsAbiertosGarantiaTaller
          ticketsAbiertos.garantia_sin_atencion     = cantidades.ticketsAbiertosGarantiaSinAtencion
        }
        vm.$store.dispatch('setContadores', ticketsAbiertos)
        callback && callback(null)
      }, function (err) {
        callback ? callback(err) : notify(vm, 'error', 'Error', err.message)
      })
    },
    closeModalEditarCita () {
      var vm = this
      vm.isModalEditarCita = false
    },
    fetchCita () {
      var vm = this
      var obj = {
        codigo: vm.ticket.idCita
      }
      // vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obtener información de la cita' })
      apiGet(vm, '/cita/obtener', obj, function (data) {
        vm.datosCita = data.lista[0]
        vm.datosCita.fechaCita = moment(vm.datosCita.fechaDesde).format('YYYY-MM-DD')
        vm.datosCita.horaCita = moment(vm.datosCita.fechaDesde).format('HH:mm')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        // vm.$store.dispatch('transaccion', { isProceso : false })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.is-closed-desktop
  height calc(100vh - 74px) !important
.is-closed-movil
  height: calc(100vh - 121px) !important;
.is-movil-time-line
  height: calc(100vh - 230px) !important
.content-time-line
  height calc(100vh - 183px)
  overflow-y auto
  overflow-x hidden
  .floating
    position absolute
    top 20px
    right  40px
  .count
    position sticky
    top 20px
    z-index 100
    left: 20px
  .left-45
    left: 45% !important
.position-sticky
  position: sticky;
  top     : 48px;
  z-index : 5;
.box-agentes
  max-height: 200px;
  overflow-y: auto;
.tabs-style
  border-radius: 4px;
  box-shadow: 0 2px 1px -1px #00000038, 0 1px 1px 0 #00000038, 0 1px 3px 0 #00000038 !important
  margin 3px
.tipo-integracion
  position: absolute;
  top     : 15px;
  right   : 15px;
.cursor-step
  cursor pointer
.pointer-events
  pointer-events: none;

.word-break-message
  word-break: break-word !important
.banner-deuda {
  width: 55%;
  background-color: #ff3860;
  color: white;
  font-weight: bold;
  padding: 1px;
  border-radius: 15px;
  margin-top: 2px;
  text-align: center;
  letter-spacing: 1px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
}
.banner-ok {
  width: 55%;
  background-color: #23d160;
  color: white;
  font-weight: bold;
  padding: 1px;
  border-radius: 15px;
  margin-top: 2px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// View_detalle_ticket.vue?0e1dfcce